(function(){
    angular.module('tmx-app').directive("tmxMultiSelect", tmxMultiSelect);

    function tmxMultiSelect() {
        return {
            scope: {
                value: "=",
                required: "=",
                placeholder: "@",
                name: "@",
                label: "@",
                options: "=",
                form: '=',
                disabled: '=',
                onItemSelected: '&',
                id:'@',
                hiddenValueField:'@',
                visibleValueField:'@'
            },
            restrict: 'E',
      // replace: true,
            priority: 100,
            templateUrl: 'common/directives/tmxmultiselect/tmxmultiselect.html',
            controller: tmxMultiSelectCtrl,
            controllerAs: 'multiSelectCtrl'
        };
    }

    function tmxMultiSelectCtrl($scope, $element, $attrs) {

    
        var self = this;
        self.scope = $scope;

        self.scope.hiddenValueField = self.scope.hiddenValueField ? self.scope.hiddenValueField : 'LookupId';
        self.scope.visibleValueField = self.scope.visibleValueField ? self.scope.visibleValueField : 'VisibleValue';

        self.scope.optionSelected = function() {
        

            if (angular.isFunction(self.scope.onItemSelected()))
                self.scope.onItemSelected($scope)(self.scope.value);
        };
    
        self.scope.onClose = function() {


            var element = document.getElementById('container-label');
            if (self.scope.value ==null || self.scope.value.length == 0) {
                element.style.visibility = 'hidden';
            }
            else {
                element.style.visibility = 'visible';
            }

        };

    }

})();